import { LocaleService } from "@/services/global-services";
import { useLocaleStore } from "@/stores";
import { useEffect } from "react";
import usePageEditorStore from "../../store/usePageEditorStore";

const RegionManager = () => {
    const availableRegions = useLocaleStore((state) => state.availableRegions);
    const activeRegion = useLocaleStore((state) => state.activeRegion);

    const setRegions = usePageEditorStore((state) => state.setRegions);
    const setActiveRegion = usePageEditorStore((state) => state.setActiveRegion);

    useEffect(() => {
        if (availableRegions.length > 0 && activeRegion) {
            setRegions(availableRegions);
            setActiveRegion(activeRegion);
        } else {
            LocaleService.get().then(setRegions);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};

export default RegionManager;
